import type { ContentKey } from '$global/utils/contentKey';
import { track } from '$global/utils/track';

/**
 * Artwork/product view event carrying the global content key (HB-959).
 *
 * Before this there was no PDP view event at all — views were only visible as
 * OpenPanel's automatic `screen_view`, whose only content signal is the URL.
 * That is exactly what HB-959 sets out to replace: `screen_view` cannot express
 * medium or price band, and its URL shape differs per site.
 *
 * The caller supplies the already-built content key so each site maps its own
 * artwork shape (there is no shared artwork type across editions, primary,
 * books, merch and NFT).
 */
export const trackArtworkView = (event: string, contentKey: ContentKey) => {
	track(event, { ...contentKey });
};
